/**
 * Array.includes wrapper with type narrowing.
 */
export function includes<U, T extends U>(arr: ReadonlyArray<T>, searchElement: U): searchElement is T {
    return arr.includes(searchElement as T)
}
